var _path, _path2, _path3, _line, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00023 10.0001C2.00024 7.79092 3.79109 6.00007 6.00022 6.00007L66.0002 6C68.2094 6 70.0003 7.79086 70.0003 10V60C70.0003 62.2091 68.2094 64 66.0003 64H6.00001C3.79087 64 2.00001 62.2091 2.00002 60L2.00023 10.0001Z",
    fill: "#FFEADB",
    stroke: "#EF7C00",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9999 50V58.2901C68.9999 60.8909 67.5045 63 65.656 63H56L68.9999 50Z",
    fill: "#FDBD90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48L54 64",
    stroke: "#EF7C00",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 15,
    x2: 17,
    y2: 37,
    stroke: "#A7163E",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17C22.0523 17 22.5 16.5523 22.5 16C22.5 15.4477 22.0523 15 21.5 15L21.5 17ZM12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17L12 15ZM21.5 37C22.0523 37 22.5 36.5523 22.5 36C22.5 35.4477 22.0523 35 21.5 35L21.5 37ZM12 35C11.4477 35 11 35.4477 11 36C11 36.5523 11.4477 37 12 37L12 35ZM21.5 15L12 15L12 17L21.5 17L21.5 15ZM21.5 35L12 35L12 37L21.5 37L21.5 35Z",
    fill: "#A7163E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgName);
export default __webpack_public_path__ + "static/media/imgName.633df76e9b748bb80e41fcc7998a0127.svg";
export { ForwardRef as ReactComponent };